import Skeleton from "react-loading-skeleton";
import "./styles.scss";

const ButtonSkeleton = ({ containerStyle = {} }) => {
  return (
    <div className="button-skeleton-container" style={{ ...containerStyle }}>
      <Skeleton height={60} baseColor="#F8FAFC" highlightColor="#E3E8EF" />
    </div>
  );
};

export default ButtonSkeleton;
